import httpClient from '../../http'
import services, { LOG_SUCCESS } from '../../logger'
import { Store, USER, PLAKA } from '@/store'
import JPlakaProcess, { DIMENSION_ROLES, ELEMENT_TYPES } from './JPlakaProcess'
export const PLK_TOKEN = 'PLK_TOKEN'
export const PLK_USER = 'PLK_USER'
export const PLK_PASSWORD = 'PLK_PASSWORD'

let _listeningObjects = []

const _getToken = (conn) => {
  const user = Store.getters[USER.GETTERS.GET_USER_TO_CONNECTION](conn.id)
  return user ? user.token : undefined
}
const _getFilters = (conn, filter = []) => {
  return Store.getters[PLAKA.GETTERS.GET_FILTERS](filter)
}
const _requestHeader = (conn) => {
  let headers = {}
  headers[PLK_TOKEN] = _getToken(conn)
  headers['Content-Type'] = 'application/json'
  return headers
}
const _getData = async (conn = {}, elements = [], conditions = [], { pages = [] } = {}) => {
  const response = await httpClient({
    method: 'post',
    url: '/abstraction/query',
    baseURL: conn.url,
    headers: _requestHeader(conn),
    data: {
      pages: pages,
      elements: elements.map(e => { return { ...Object.assign({}, e), ...{ idStatistic: conn.idStatistic, idSchema: conn.idSchema } } }),
      conditions: conditions.map(c => { return { ...Object.assign({}, c), ...{ idStatistic: conn.idStatistic, idSchema: conn.idSchema } } })
    },
    params: {
      folderAbstraction: conn.folder,
      abstraction: conn.abstraction
    }
  })
  return new JPlakaProcess(response.data)
}
const _clearFilter = function (idElement, fields2notify = []) {
  let filters = _getFilters(this).filter(f => f.idElement !== idElement)
  Store.commit(PLAKA.MUTATIONS.SET_FILTERS, {
    filters,
    fields2notify
  })
}
const _containsIdElement = (elements = [], filter = []) => elements.filter(e => filter.indexOf(e.idElement) !== -1).length > 0

const validateFields = (connection) => {
  return connection.id && connection.type && connection.url && connection.folder && connection.abstraction
}
const login = async function (username, password) {
  const header = {}
  header[PLK_USER] = username
  header[PLK_PASSWORD] = password
  const response = await httpClient({
    method: 'get',
    url: '/users/token',
    baseURL: this.url,
    headers: header
  })
  return response.data.resource
}
const getStatistics = async function () {
  const response = await httpClient({
    method: 'get',
    url: '/abstraction/statistics',
    baseURL: this.url,
    headers: _requestHeader(this),
    params: {
      folderAbstraction: this.folder,
      abstraction: this.abstraction
    }
  })
  return response.data
}
const getDimensions = async function () {
  const response = await httpClient({
    method: 'get',
    url: '/abstraction/dimensions',
    baseURL: this.url,
    headers: _requestHeader(this),
    params: {
      folderAbstraction: this.folder,
      abstraction: this.abstraction,
      idStatistic: this.idStatistic,
      idSchema: this.idSchema
    }
  })
  return response.data
}
const getColumns = async function (dimension = {}) {
  const response = await httpClient({
    method: 'get',
    url: '/abstraction/dimensions/columns',
    baseURL: this.url,
    headers: _requestHeader(this),
    params: {
      folderAbstraction: this.folder,
      abstraction: this.abstraction,
      idStatistic: this.idStatistic,
      idSchema: this.idSchema,
      idElement: dimension.idElement
    }
  })
  return response.data
}
const getColumnValues = async function (column = {}) {
  const response = await httpClient({
    method: 'get',
    url: '/abstraction/dimensions/columns/values',
    baseURL: this.url,
    headers: _requestHeader(this),
    params: {
      folderAbstraction: this.folder,
      abstraction: this.abstraction,
      idStatistic: this.idStatistic,
      idSchema: this.idSchema,
      idElement: column.idElement
    }
  })
  return response.data
}
const getMeasures = async function () {
  const response = await httpClient({
    method: 'get',
    url: '/abstraction/measures',
    baseURL: this.url,
    headers: _requestHeader(this),
    params: {
      folderAbstraction: this.folder,
      abstraction: this.abstraction,
      idStatistic: this.idStatistic,
      idSchema: this.idSchema
    }
  })
  return response.data
}
const initData = function (elements = [], conditions = [], { onInit, onChange } = {}, { pages = [] } = {}) {
  validateFields(this)
  _listeningObjects.push({ elements, conditions, onInit, onChange, pages, conn: this })
  if (onInit) onInit()
  if (onChange) {
    const filters = _getFilters(this, elements.map(e => e.idElement).concat(conditions.map(c => c.idElement)))
    _getData(this, elements, filters, { pages }).then((data) => {
      onChange(data)
    })
  }
}
const stopData = function ({ onInit, onChange } = {}) {
  _listeningObjects = _listeningObjects.filter((item) => item.onInit !== onInit && item.onChange !== onChange)
}
const getDataByPage = function (elements = [], conditions = [], { pages = [] } = {}) {
  return _getData(this, elements, conditions, { pages })
}
const getFilters = function () {
  return _getFilters(this, [])
}
const applyFilters = function (filters = [], { overwrite = true } = {}) {
  let failValidation = false
  filters.forEach(filter => {
    if (!filter.type === ELEMENT_TYPES.COLUMN || !filter.idElement || !filter.values) {
      services.logger('ServicePlaka', `applyFilter:bad format in filter:${JSON.stringify(filter)}`, LOG_SUCCESS)
      failValidation = true
    } else if (overwrite) {
      _clearFilter(filter.idElement, [])
    }
  })
  if (!failValidation) {
    const appliedFilters = Object.assign([], Store.getters[PLAKA.GETTERS.GET_FILTERS]())
    filters.forEach(filter => appliedFilters.push(filter))
    Store.commit(PLAKA.MUTATIONS.SET_FILTERS, {
      filters: appliedFilters,
      fields2notify: filters
    })
  }
}
const applyFilter = function (filter, { overwrite = true } = {}) {
  if (!filter.type === ELEMENT_TYPES.COLUMN || !filter.idElement || !filter.values) {
    services.logger('ServicePlaka', `applyFilter:bad format in filter:${JSON.stringify(filter)}`, LOG_SUCCESS)
    return
  }
  if (overwrite) _clearFilter(filter.idElement, [])
  const appliedFilters = Object.assign([], Store.getters[PLAKA.GETTERS.GET_FILTERS]())
  appliedFilters.push(filter)
  Store.commit(PLAKA.MUTATIONS.SET_FILTERS, {
    filters: appliedFilters,
    fields2notify: [filter]
  })
}
const clearFilter = function (filter) {
  _clearFilter(filter.idElement, [filter])
}
const clearAll = function () {
  Store.commit(PLAKA.MUTATIONS.SET_FILTERS, {
    filters: [],
    fields2notify: _getFilters(this, [])
  })
}
const evaluate = function (fields2notify) {
  const listFields = (fields2notify || _getFilters(this, [])).map(f => f.idElement)
  _listeningObjects.forEach(l => {
    if (_containsIdElement(l.elements, listFields) || _containsIdElement(l.conditions, listFields) || _containsIdElement(l.pages, listFields)) {
      const filters = _getFilters(this, l.elements.map(e => e.idElement).concat(l.conditions.map(c => c.idElement)))
      if (l.onInit) l.onInit()
      if (l.onChange) {
        _getData(l.conn, l.elements, filters, { pages: l.pages }).then((data) => {
          l.onChange(data)
        })
      }
    }
  })
}
const loginInApp = function (username, password) {
  return Store.dispatch({
    type: USER.ACTIONS.LOGIN,
    connection: this,
    username: username,
    password: password
  })
}

export default {
  DIMENSION_ROLES,
  ELEMENT_TYPES,
  validateFields,
  loginInApp,
  login,
  getStatistics,
  getDimensions,
  getMeasures,
  getColumns,
  getColumnValues,
  initData,
  stopData,
  getDataByPage,
  getFilters,
  applyFilters,
  applyFilter,
  clearFilter,
  clearAll,
  evaluate
}
